module.exports = __webpack_public_path__ + "static/rightAlignedWhyReload-f66bf02e2bee172994995daef289c8bc.png";